import React from 'react';
import PropTypes from 'prop-types';
import { getTranslation } from '@resy/ui-kitchen';

import KnifeFork from '../../../../../ui-kitchen/src/svg/icons/ic-col-Dine-In.svg';
import WineGlass from '../../../../../ui-kitchen/src/svg/icons/IconWineGlass.svg';
import UiMapIcon from '../../../../../ui-kitchen/src/svg/icons/ui_map.svg';
import VenueTypeSearchPill from './VenueTypeSearchPill';
import './SearchVenueTypePills.scss';

const noop = () => {};

const VenueTypeSearchPillGroup = ({ onSelect }) => {
  const options = [
    {
      key: 'restaurants',
      icon: KnifeFork,
      iconName: 'knife-fork',
      label: getTranslation({
        translationKey: 'venue_type_search_pill_restaurants',
        fallback: 'Restaurants',
      }),
    },
    {
      key: 'wineries',
      icon: WineGlass,
      iconName: 'wine-glass',
      label: getTranslation({
        translationKey: 'venue_type_search_pill_wineries',
        fallback: 'Wineries',
      }),
    },
    {
      key: 'all-venues',
      icon: UiMapIcon,
      iconName: 'ui-map',
      label: getTranslation({
        translationKey: 'venue_type_search_pill_all_venues',
        fallback: 'All Venues',
      }),
    },
  ];

  return (
    <div className="SearchVenueTypePills">
      <div className="SearchVenueTypePills__group">
        {options.map((option) => (
          <VenueTypeSearchPill
            key={option.key}
            icon={option.icon}
            iconName={option.iconName}
            label={option.label}
            onClick={onSelect ? () => onSelect(option.key) : undefined}
          />
        ))}
      </div>
    </div>
  );
};

VenueTypeSearchPillGroup.propTypes = {
  onSelect: PropTypes.func,
};

VenueTypeSearchPillGroup.defaultProps = {
  onSelect: noop,
};

export default VenueTypeSearchPillGroup;
